import * as React from 'react'

function SvgPackageLoveIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.046.344a.81.81 0 00-.273.055L.858 4.36a.773.773 0 00-.547.734v12.502a.775.775 0 00.609.75l9.712 4.375c.253.164.617.17.867-.007l6.024-2.712 1.493 1.602c.296.318.811.318 1.094 0l3.477-3.72c.952-1.026.978-2.696 0-3.734a2.49 2.49 0 00-1.774-.805v-8.25a.774.774 0 00-.563-.743L11.35.4a.798.798 0 00-.304-.055zm.016 1.555l7.97 3.187-2.97 1.196-7.97-3.188 2.97-1.195zm-5.001 2l7.97 3.188-2.97 1.195-7.97-3.196L6.062 3.9zM1.81 6.204l8.5 3.399v11.329l-8.5-3.82V6.203zm18.502 0v7.641c-.119.09-.24.19-.344.305l-.407.438-.406-.438c-1.07-1.044-2.629-1.081-3.617 0a2.755 2.755 0 000 3.735l.906.968-4.633 2.079V9.602l3.5-1.398v2.89c-.005.397.354.759.75.759s.756-.362.75-.758V7.602l3.5-1.398zm1.46 8.626c.25 0 .507.115.72.343.425.457.425 1.231 0 1.688l-2.93 3.141-2.93-3.14c-.426-.457-.426-1.232 0-1.689a.963.963 0 01.719-.32c.249 0 .496.09.71.32l.946 1.024c.28.303.822.303 1.102 0l.953-1.024c.213-.228.461-.343.711-.343z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgPackageLoveIcon
